import React,{useEffect,useState} from "react";
import notificationImage from "../../assets/images/notification.svg";
import logOutImage from "../../assets/images/logout.svg";
import userImage from "../../assets/images/user.svg";
import { useNavigate } from "react-router-dom";
import { useSelector ,useDispatch} from "react-redux";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu ,DropdownItem} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { fetchAllNotifications, signoutUser, updateActiveAccount } from "../../redux/action";
import Avatar from 'react-avatar';

import $ from 'jquery'
const NotificationItem = (data) => {
  return (
    <div className="d-flex flex-row mb-3 pb-3 border-bottom">
      <div className="pl-3 pr-2">
          <span style={{backgroundColor:'#5C5BE3'}} className="badge badge-pill badge-primary handle mr-1 ml-5 mb-2"> {data.account.name}</span>
          <p className="text-muted mb-0 text-small">Messages: {data.messages.length} </p>
          <p className="text-muted mb-0 text-small">Voicemails: {data.voicemails.length} </p>
      </div>
    </div>
  );
};




function Header({title}) {
  const authUser=useSelector((state)=>state.authUser)
  const notifications=useSelector((state)=>state.notifications)
  const dispatch=useDispatch()
  const navigate=useNavigate()
  const [isNotification,setIsNotification]=useState(false)

  const handleLogout=()=>{
    dispatch(signoutUser())
    navigate('/login')
  }

  const getNotifications=()=>{
   dispatch(fetchAllNotifications())
  }

  const gatherNotification=()=>{
   for(let i=0;i<notifications.data.length;i++){
    if(notifications.data[i].messages.length>0 && notifications.data[i].account.id==authUser.activeAccount){
      setIsNotification(true)
      return
    }
    if(notifications.data[i].voicemails.length>0 && notifications.data[i].account.id==authUser.activeAccount){
      setIsNotification(true)
      return
    }
   }
   setIsNotification(false)
  }

  useEffect(()=>{
    getNotifications()
    //gatherNotification()
  },[])

  useEffect(()=>{
    gatherNotification()
  },[notifications])
  const showLeft=()=>{
    $(".left-navigation").animate({
      width: "20%",
      padding: "30px 20px"
  });
  $(".main-section").css("width", "80%");
  $("#headerMenuBtn").addClass("d-none");
  $("#leftMenuBtn").removeClass("d-none");


  }
  const handleMobileHeaderClick=()=>{
    $(".left-navigation").css('display', 'block');
    $(".left-navigation").css('width', '100%');

  }


  return (
    <div className="header d-flex justify-content-between" style={{marginTop:"12px"}}>
      <div className="d-flex align-items-center">
        <button
          onClick={showLeft}
          id="headerMenuBtn"
          className="menu-btn me-2 d-none desktop-display"
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        <button 
          onClick={handleMobileHeaderClick}
          id="mobileHeaderMenuBtn"
          className="menu-btn me-2 mobile-display"
        >
          <i className="fa-solid fa-bars"></i>
        </button>
        <div className="main-head">Dashboard</div>
      </div>
      <div className="controls d-flex">
        <div className="position-relative d-inline-block">
         {/*<img src={notificationImage} />*/}
         <UncontrolledDropdown className="dropdown-menu-right" >
          <DropdownToggle
            className="header-icon notificationButton"
            color="empty"
            style={{padding:'0px',borderRadius:"50%"}}
          >
         <img src={notificationImage} /> 
         <div className={`${isNotification ? 'notification-count-dot':''} `}></div>         
         </DropdownToggle>
          <DropdownMenu
            className="position-absolute mt-3 scroll"
            end
         
          >
            <PerfectScrollbar
              options={{ suppressScrollX: true, wheelPropagation: false }} style={{padding:'10px'}}
            >
              {notifications.data.map((notification, index) => {
                return <NotificationItem key={index} {...notification} />;
              })}
            </PerfectScrollbar>
          </DropdownMenu>
        </UncontrolledDropdown>
        </div>



       {/*from here */}

  
       <div className="ms-3 d-flex align-items-center">
       <UncontrolledDropdown className="dropdown-menu-right">
              <DropdownToggle className="p-0" color="empty">
                { authUser.user &&  
                  <span>
                    <span>
                    <Avatar size={45} name={authUser.user.full_name} round />
                      {/*<img alt="Profile" src={userImage} />*/}
                    </span>
                    <span className="user-name ms-2">{authUser.user.full_name}</span>
                    
                  </span>    
                }
                
              </DropdownToggle>
              <DropdownMenu className="mt-3" end>

                {authUser?.user?.accounts?.map((item, index) => {
                  return(
                    <DropdownItem 
                    key={index}
                     onClick={() => dispatch(updateActiveAccount(item.id))}
                      active={item.id == authUser.activeAccount}
                    >
                        {item.name}
                    </DropdownItem>
                  )
                })}
              </DropdownMenu>
            </UncontrolledDropdown>

        </div>



       {/* till here*/}



        {/*
        <div className="ms-3 d-flex align-items-center">
          <img src={userImage} />
          <span className="user-name ms-2">{authUser.user.full_name}</span>
            </div>*/}





        <div className="ms-4" onClick={handleLogout}>
          <img src={logOutImage} />
        </div>
      </div>
    </div>
  );
}

export default Header;
